"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
class RadioGroup extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    borderColor: theme.borderColor1,
                    borderWidth: 1,
                    borderRadius: 3,
                    backgroundColor: theme.backgroundColor2,
                    flexDirection: 'row',
                    justifyContent: 'space-around'
                },
                item: {
                    paddingVertical: (0, layout_1.isTablet)() ? 10 : 5,
                    borderColor: theme.borderColor1,
                    flex: 1,
                    alignItems: 'center'
                },
                itemText: {
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 16 : 12,
                    lineHeight: (0, layout_1.isTablet)() ? 20 : 16,
                    color: theme.textColor3
                },
                selectedItem: {
                    backgroundColor: theme.backgroundColor3
                },
                selectedItemText: {
                    color: theme.textColor4
                },
                readonly: {
                    backgroundColor: theme.disabledColor
                }
            });
            return styles;
        };
    }
    render() {
        const { items, value, onChange, disabled } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { style: styles.container }, items.map((item, index) => (React.createElement(react_native_1.TouchableWithoutFeedback, { key: index, disabled: disabled && disabled.includes(item.value), onPress: () => onChange(item.value) },
            React.createElement(react_native_1.View, { style: [
                    styles.item,
                    { borderRightWidth: index === items.length - 1 ? 0 : 1 },
                    item.value === value ? styles.selectedItem : null,
                    disabled && disabled.includes(item.value)
                        ? styles.readonly
                        : null
                ] },
                React.createElement(react_native_1.Text, { style: [
                        styles.itemText,
                        item.value === value ? styles.selectedItemText : null
                    ] }, item.label)))))));
    }
}
exports.RadioGroup = RadioGroup;
